export const workspaceMenuItems = [
  {
    id: 1,
    label: "common.library",
    isTitle: true,
  },
  {
    id: 2,
    label: "FwSed",
    icon: "bx-data",
    subItems: [
      {
        id: "policy-parent",
        label: "policy.text",
        subItems: [
          {
            id: "policy",
            label: "policy.text",
            link: "/workspace/library/policy",
          },
          {
            id: "policy-category",
            label: "policy-category.text",
            link: "/workspace/library/policy-category",
          },
        ],
      },

      {
        id: "question-set",
        label: "question-set.plural",
        subItems: [
          {
            id: "question-set",
            label: "question-set.plural",
            link: "/workspace/library/question-set",
          },
          {
            id: "question",
            label: "question.text",
            link: "/workspace/library/question",
          },
        ],
      },
    ],
  },
];
